module.exports = __webpack_public_path__ + "images/emails/bg-page-r-6e9d7844.gif";